(function () {
    'use strict';

    angular
        .module('homeControllers')
        .controller('HomeController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'recomService', 'recomActionPlanUpdateStatusService'];

    function Controller($scope, $state, topBarService, recomService, recomActionPlanUpdateStatusService) {
        topBarService.setModule(undefined);
        topBarService.setTitleAndIcon('', '');

        $scope.actionPlanOwners = [];

        // Browse risks
        $scope.browseRisks = function () {
            $state.go('home', {
                q: 'type=Risk'
            }, { reload: true });
        };

        // Browse controls
        $scope.browseControls = function () {
            $state.go('home', {
                q: 'type=Control'
            }, { reload: true });
        };

        // Recom Business Units
        recomService.getAvailableBusinessUnits()
            .then(function (businessUnits) {
                $scope.availableRecomBusinessUnits = businessUnits;
                _.each(businessUnits, function (businessUnit) {
                    recomActionPlanUpdateStatusService.getOwnersAndStatus(businessUnit.RecomBusinessUnitID).then(function (actionPlanOwners) {
                        $scope.actionPlanOwners.push({
                            recomBusinessUnitID: businessUnit.RecomBusinessUnitID,
                            actionPlanOwnersStats: actionPlanOwners
                        });
                    });
                });
            });

        // Get Number of Action Plans Owners By Status
        $scope.getNumberOfActionPlanOwnersByStatus = function (recomBusinessUnitID, status) {
            var actionPlanOwners = $scope.getActionPlanOwnersByStatus(recomBusinessUnitID, status);
            if (_.isUndefined(actionPlanOwners) || actionPlanOwners == null) return 0;
            return actionPlanOwners.length;
        };

        // Get Action Plan Owners By Status
        $scope.getActionPlanOwnersByStatus = function (recomBusinessUnitID, status) {
            var actionPlanOwner = _.filter($scope.actionPlanOwners, { recomBusinessUnitID: recomBusinessUnitID });
            if (_.isUndefined(actionPlanOwner)) { return; }
            if (actionPlanOwner.length > 0) {
                var actionPlanOwnersByStatus = _.groupBy(actionPlanOwner[0].actionPlanOwnersStats, function (actionPlanOwner) {
                    return actionPlanOwner.OwnerStatusValue.toLowerCase();
                });
                return actionPlanOwnersByStatus[status];
            }
            else {
                return null;
            }
        };

        $scope.getOwnerStatusCountByBusinessUnit = function (recomBusinessUnitID) {
            if (_.isUndefined($scope.actionPlanOwners)) { return 0; }
            var actionPlanOwnerByBusinessUnit = _.filter($scope.actionPlanOwners, { recomBusinessUnitID: recomBusinessUnitID });
            if (_.isUndefined(actionPlanOwnerByBusinessUnit)) { return 0; }
            if (_.isUndefined(actionPlanOwnerByBusinessUnit[0])) { return 0; }
            else
            { return actionPlanOwnerByBusinessUnit[0].actionPlanOwnersStats.length; }
        };

        $scope.getCompletionPercentage = function (recomBusinessUnitID) {
            var actionPlanOwner = _.filter($scope.actionPlanOwners, { recomBusinessUnitID: recomBusinessUnitID });

            if (_.isUndefined(actionPlanOwner)) { return; }

            if (actionPlanOwner.length > 0) {
                var completedCount = _.filter(actionPlanOwner[0].actionPlanOwnersStats, { OwnerStatusValue: 'Completed' }).length;
                var totalCount = actionPlanOwner[0].actionPlanOwnersStats.length;
                var perct = (completedCount / totalCount) * 100;
                if (perct)
                    return perct;
            }
            return 0;
        };


    }
})();